var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.35 153.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#bbe6d6;}.cls-3{fill:#92cebd;}.cls-4{fill:#d7bd75;}.cls-5{fill:#c5a764;}.cls-6{fill:#e6d691;}.cls-7{fill:#808285;}.cls-8{fill:#59595a;}.cls-9{fill:#2e3054;}.cls-10,.cls-12,.cls-15{fill:#fff;}.cls-10{opacity:0.2;}.cls-11{fill:#eaedff;}.cls-13{fill:#596a83;}.cls-14{fill:#95dee6;}.cls-15{opacity:0.5;}.cls-16{fill:#d5aa7a;}.cls-17{fill:#8d634a;}.cls-18{fill:#ccaa38;}.cls-18,.cls-20,.cls-21{mix-blend-mode:multiply;}.cls-19{fill:#e4be7a;}.cls-20{fill:#ddd8bd;}.cls-21{fill:#868f7a;}.cls-22{fill:#9e794a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Digital Order By Retailers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.17,70.17V80c23.64,4,41.18,18.56,41.18,36v.08h0v32.31c0,2.13-2.43,3.87-5.42,3.87H12.55c-3,0-5.42-1.74-5.42-3.87V116.06h0V116c0-17.42,17.54-32,41.17-36V70.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.17,80V70.17H61.83v82.07h48.1c3,0,5.42-1.74,5.42-3.87V116.06h0V116C115.35,98.56,97.81,84,74.17,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.3,70.17V80a69.38,69.38,0,0,0-15,4.27l28,34.5,28-34.5A69.47,69.47,0,0,0,74.17,80V70.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.78,70.17c-.19.6-.34,1.23-.48,1.89v1.33L79.84,95.84l9.39-11.57A69.47,69.47,0,0,0,74.17,80V70.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.36,40c0,20.15-13.2,36.5-29.48,36.5S32.41,60.17,32.41,40s13.2-36.5,29.47-36.5S91.36,19.86,91.36,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M62.71,3.54l1.17,72.88C79.23,75.15,91.36,59.34,91.36,40,91.36,20.2,78.6,4.08,62.71,3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73.5,19.44s-21,8.15-32.62,2.33c0,0-7,17.47-6.21,32.61,0,0-13.6-35.33,12.81-50.09s44.26,12,45,27.19S91,50.11,91,50.11,91.74,22.54,73.5,19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M63.12,0V22.46a78.66,78.66,0,0,0,10.38-3C91.74,22.54,91,50.11,91,50.11s2.33-3.49,1.55-18.63C91.91,19.56,80.72.45,63.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.36,151.38a1.67,1.67,0,0,1-1.66,1.68h-48A1.67,1.67,0,0,1,0,151.38V70.29a1.66,1.66,0,0,1,1.66-1.67h48a1.67,1.67,0,0,1,1.66,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M51.36,83.61V70.29a1.67,1.67,0,0,0-1.66-1.67h-48A1.66,1.66,0,0,0,0,70.29v65.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M48.32,139.6a1.4,1.4,0,0,1-1.46,1.33H4.5A1.4,1.4,0,0,1,3,139.6V75A1.4,1.4,0,0,1,4.5,73.61H46.86A1.4,1.4,0,0,1,48.32,75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M48.32,99V97.06l-1.59-1.59,1.59-1.58V92l-2.53,2.53-5.31-5.31,7.84-7.84v-1.9l-8.79,8.79L28.44,77.18,32,73.61H30.12L27.5,76.24l-2.63-2.63H23l3.57,3.57-8.37,8.37L6.23,73.61H4.35L17.23,86.5,7.65,96.08,3,91.47v1.89L6.7,97,3,100.69v1.9L7.65,98l11.09,11.09L3,124.77v1.89L19.69,110,25,115.32l-22,22v1.89l22.9-22.9,22.38,22.37v-1.89L26.89,115.32l9.58-9.58,11.85,11.85V115.7l-10.9-10.91,8.37-8.37ZM27.5,78.13,38.59,89.22l-8.38,8.37L19.12,86.5ZM8.6,97l9.58-9.58L29.27,98.54l-9.58,9.58Zm17.34,17.34-5.31-5.31,9.58-9.58,5.31,5.31Zm10.53-10.52-5.31-5.31,8.37-8.37,5.31,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M29.71,147a4,4,0,1,1-4-4A4,4,0,0,1,29.71,147Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M28.74,147a3.08,3.08,0,1,1-3.07-3.08A3.06,3.06,0,0,1,28.74,147Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M46.86,73.61H4.5A1.4,1.4,0,0,0,3,75V81.5H48.32V75A1.4,1.4,0,0,0,46.86,73.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 5.77,
    y: 75.36,
    width: 5.64,
    height: 0.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 5.77,
    y: 77.3,
    width: 5.64,
    height: 0.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 5.77,
    y: 79.25,
    width: 5.64,
    height: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M44.66,75.12a.61.61,0,1,1-.61-.62A.61.61,0,0,1,44.66,75.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M44.66,77.2a.61.61,0,1,1-.61-.61A.61.61,0,0,1,44.66,77.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M44.66,79.29a.61.61,0,0,1-1.22,0,.61.61,0,1,1,1.22,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 11.47,
    y: 95.14,
    width: 27.11,
    height: 23.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 11.47,
    y: 118.92,
    width: 27.11,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 24.98,
    y: 96.47,
    width: 0.14,
    height: 20.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 24.74,
    y: 96.47,
    width: 0.24,
    height: 20.87,
    transform: "translate(49.73 213.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 11.47,
    y: 95.14,
    width: 27.11,
    height: 0.96
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "12.99 117.32 12.99 95.14 11.47 95.14 11.47 118.96 38.58 118.96 38.58 117.32 12.99 117.32"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 23.25,
    y: 95.13,
    width: 4.85,
    height: 24.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 23.44,
    y: 95.13,
    width: 4.65,
    height: 23.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 31.11,
    y: 112.61,
    width: 4.64,
    height: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.69,116.06h.13v-3h-.13Zm.33,0h.34v-3H34Zm-2.47,0h.5v-3h-.5Zm1.85,0h.12v-3H33.4Zm1.16-3v3h.67v-3Zm-2.23,3h.19v-3h-.19Zm.57,0h.3v-3h-.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.23 113.48 19.67 112.73 19.11 113.48 19.44 113.48 19.44 115.41 19.89 115.41 19.89 113.48 20.23 113.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.5 113.48 20.93 112.73 20.37 113.48 20.71 113.48 20.71 115.41 21.16 115.41 21.16 113.48 21.5 113.48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.19,
    y: 115.56,
    width: 2.22,
    height: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.32,114a.49.49,0,0,1,.43.26.61.61,0,0,1,.46-.26.52.52,0,0,1,.44.26.58.58,0,0,1,.46-.26.46.46,0,0,1,.23.06,1.25,1.25,0,0,0-2.48.2A.58.58,0,0,1,14.32,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,112.73c0-.06,0-.11-.07-.11s-.08,0-.08.11v2.52c0,.14,0,.38-.19.38s-.2-.13-.2-.29a.09.09,0,0,0-.08-.09.08.08,0,0,0-.08.09.42.42,0,0,0,.36.46.34.34,0,0,0,.3-.22,1.81,1.81,0,0,0,0-.53v-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.71,115.43v-1.2a.65.65,0,0,0,.38-.37l-.54-.66.23-.07-.18-.41H17a2.53,2.53,0,0,0,0,.28c0,.63.24,1.15.56,1.23v1.2c-.25,0-.44.09-.44.19s.23.18.52.18.52-.08.52-.18S18,115.45,17.71,115.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.41,112.79l-.66,0,.17.42-.23.06.51.69a1.94,1.94,0,0,0,.21-.86A1.31,1.31,0,0,0,18.41,112.79Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrder);
export default __webpack_public_path__ + "static/media/icon-order.a4c6c4143ec01dcda70b8ddeadbf81b3.svg";
export { ForwardRef as ReactComponent };